import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import VExportPaymentService from '../../../../Services/VExportPaymentService';
import VoidAndReissueParamsItem from '../../../../Domain/VoidAndReissueParamsItem';

export default class VoidWindowDescription {
  static titleForCreate = 'Void';
  static titleForEdit = 'Void';
  static finishButtonLabel = 'Void';
  static itemType = VoidAndReissueParamsItem;
  static serviceFunction = (edited) => VExportPaymentService.Void(edited);
  static waitForServiceFunction = () => false;
  static messageOnSuccess =
    'The Void process has been started. You will receive a notification about the result in your personal notification repository.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [{ fieldName: 'Reason', label: 'Reason', className: 'col-12', type: InputTypesEnum.TextBox }],
    },
  ];
}
